import { SubpageLayout } from '@/components/architecture/Layout/SubpageLayout';
import { Grid } from '@/components/layout/Grid';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { Loader } from '@/components/progress/Loader/Loader';
import { useAddeparIntegrationErrorSearchParam } from '@/modules/assetProviderIntegrations/addepar/hooks/useAddeparIntegrationErrorSearchParam';
import { useFeatureFlag } from '@/modules/featureFlags/useFeatureFlag';
import { diagnostics } from '@/utils/diagnostics';
import { getEnvironment } from '@/utils/environmentUtils';
import { getOrbTenant } from '@/utils/tenantUtils';

import { useGetUserProfileSettingsQuery } from './graphql/UserProfileSettingsPage.generated';
import { IntegrationsCard } from './IntegrationsCard/IntegrationsCard';
import { McpSetupCard } from './McpSetupCard';
import { NotificationPreferencesCard } from './NotificationPreferencesCard/NotificationPreferencesCard';

export function UserProfileSettingsPage() {
  const { createErrorFeedback } = useFeedback();
  const mcpServerEnabled = useFeatureFlag('mcp_server');
  const showMcpSetup =
    mcpServerEnabled &&
    (getEnvironment() !== 'development' || getOrbTenant() !== null);
  const { data, loading: configLoading } = useGetUserProfileSettingsQuery({
    onError: (error) => {
      diagnostics.error('failed to get user profile settings', error);
      createErrorFeedback(
        'Failed to fetch user profile settings. Please refresh the page and try again.'
      )();
    },
  });

  useAddeparIntegrationErrorSearchParam();

  return (
    <SubpageLayout>
      {configLoading ? (
        <Loader
          boxProps={{
            sx: {
              textAlign: 'center',
              my: 3,
            },
          }}
        />
      ) : (
        <Grid container spacing={2} alignItems="stretch">
          <Grid item md={6} lg={5}>
            <NotificationPreferencesCard />
          </Grid>
          <Grid item md={6} lg={4}>
            <IntegrationsCard data={data} />
          </Grid>
          {showMcpSetup && (
            <Grid item md={12} lg={6}>
              <McpSetupCard />
            </Grid>
          )}
        </Grid>
      )}
    </SubpageLayout>
  );
}
